const SubAbasOrgInters = (id: string) => [
  {
    label: 'Dados Gerais',
    rota: `/daf/proaq/orginters/${id}/dadosgerais`,
  },
  {
    label: 'Destaques',
    rota: `/daf/proaq/orginters/${id}/destaques`,
  },
];

export default SubAbasOrgInters;
